export function triggerShare(text) {
  const payload = JSON.stringify({ action: "share", text });
  window.AndroidInterface?.shareContent?.(payload);
  window.webkit?.messageHandlers?.shareContent?.postMessage?.(payload);
}

// Only rewrites the bare "goqii.com" host to "lifestyle1.goqii.com" — a plain
// substring replace would also corrupt subdomains that merely contain
// "goqii.com" (e.g. "demo-dashboard.goqii.com" -> "demo-dashboard.lifestyle1.goqii.com").
const BARE_GOQII_HOST = /^(https?:\/\/)goqii\.com(?=[/:?#]|$)/i;
const toLifestyleHost = (url) =>
  BARE_GOQII_HOST.test(url) ? url.replace(BARE_GOQII_HOST, "$1lifestyle1.goqii.com") : url;

export function navigateWithFai(title, linkUrl) {
  const params = new URLSearchParams(window.location.search);
  // const loader = params.get("loader");
  const lang = params.get("lang") || "";

  let resolvedUrl = toLifestyleHost(linkUrl);
  if (lang) {
    const theme = params.get("theme") || "";
    // const lang = params.get("lang") || "";
    resolvedUrl += `${resolvedUrl?.includes("?") ? "&" : "?"}theme=${theme}&lang=${lang}`;
  }

  const faiValue = {
    url: resolvedUrl,
    title: title,
  };

  const encodedFaiValue = encodeURIComponent(JSON.stringify(faiValue));

  const finalUrl = `https://goqii.com/app?fsn=61&fssn=0&fai=${encodedFaiValue}`;

  window.location.href = finalUrl;
}

export function navigateWithFaiWithOnTap(onTap) {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang") || "";

  const fai = { ...onTap.FAI };
  if (fai.url) {
    fai.url = toLifestyleHost(fai.url);
    if (lang) {
      const theme = params.get("theme") || "";
      fai.url += `${fai.url.includes("?") ? "&" : "?"}theme=${theme}&lang=${lang}`;
    }
  }

  const encodedFaiValue = encodeURIComponent(JSON.stringify(fai));
  const finalUrl = `https://goqii.com/app?fsn=${Number(onTap.FSN)}&fssn=${Number(onTap.FSSN)}&fai=${encodedFaiValue}`;
  window.location.href = finalUrl;
}